import { useEffect } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import MemoryButton from '../memory-button';

export const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string | React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className='fixed inset-0 z-[9999] flex items-center justify-center bg-card-color-negative bg-opacity-50'
      onClick={(e) => e.stopPropagation()}
    >
      <div className='w-11/12 max-w-3xl rounded-[16px] bg-mono-color-white shadow-level-2'>
        {/* Header */}
        <div className='border-b flex items-center justify-between p-4'>
          {typeof title === 'string' ? (
            <>
              <Typography className='text-h3 font-bold text-mono-color-darkest'>
                {title}
              </Typography>
              <button
                className='text-mono-color-black hover:text-gray-700'
                onClick={onClose}
              >
                ✕
              </button>
            </>
          ) : (
            title
          )}
        </div>

        {/* Body */}
        <div className='max-h-[70vh] overflow-y-auto p-4'>{children}</div>

        {/* Footer */}
        {footer && <div className='border-t p-4'>{footer}</div>}
      </div>
    </div>
  );
};

export const ModalNotification = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div className='flex w-full items-center justify-center'>
          <Typography className='text-center !text-h3 font-bold text-mono-color-black'>
            {title}
          </Typography>
        </div>
      }
      footer={footer}
    >
      <div className='flex flex-col gap-6'>
        {children}
        <div className='p-3'>
          <MemoryButton
            label='Fechar'
            variant='primary'
            className='w-full bg-color-brand-primary '
            onClick={onClose}
            allowReadOnly
          />
        </div>
      </div>
    </Modal>
  );
};
